import type { AuthProviderProps } from "react-oidc-context"
import { Log, WebStorageStateStore } from "oidc-client-ts"

import { env } from "@/shared/config/env"

// Log.setLogger(console)
// Log.setLevel(Log.DEBUG)

const origin = window.location.origin

const authority = env.VITE_OIDC_AUTHORITY

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: env.VITE_OIDC_CLIENT_ID,
  redirect_uri: `${origin}${env.VITE_OIDC_REDIRECT_URI}`,
  post_logout_redirect_uri: `${origin}${env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI}`,
  response_type: "code",
  scope: "openid profile email",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  monitorSession: false,
  // Supply metadata manually to avoid repeated discovery endpoint requests
  metadata: {
    issuer: authority,
    authorization_endpoint: `${authority}/protocol/openid-connect/auth`,
    token_endpoint: `${authority}/protocol/openid-connect/token`,
    userinfo_endpoint: `${authority}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${authority}/protocol/openid-connect/logout`,
    jwks_uri: `${authority}/protocol/openid-connect/certs`,
    introspection_endpoint: `${authority}/protocol/openid-connect/token/introspect`,
  },
  // PKCE requires crypto.subtle which is only available over HTTPS.
  // Disable until the app is served over HTTPS.
  disablePKCE: !window.isSecureContext,
  onSigninCallback: (user) => {
    const state = user?.state as { redirectTo?: string } | undefined
    const params = new URLSearchParams(window.location.search)
    const redirectTo = state?.redirectTo || params.get("redirectTo") || "/"
    window.history.replaceState({}, document.title, redirectTo)
  },
}
